import type { FetchRequestArgs } from '../../utils';
import { fetchRequest } from '../../utils';
import { HTTPMethod } from '../httpMethods';

export const deactivateWorkspace = async <T extends Record<string, unknown>>({
  headers,
  workspaceId,
  domain,
  query,
  signal,
}: FetchRequestArgs & { workspaceId: string }): Promise<
  ReturnType<typeof fetchRequest>
> =>
  fetchRequest<T>({
    data: { archived: true },
    domain,
    endpoint: `/v2/messaging/workspaces/${workspaceId}/deactivate`,
    headers,
    method: HTTPMethod.POST,
    query,
    signal,
  });
